export default __webpack_public_path__ + "static/banner_amj-8c8e0b6b6c9b366f658da73afe9b9e14.webp";